import { observable, action, makeObservable, runInAction } from "mobx";
import { MrbBaseViewStore } from "mrb/core/stores";
import { isNil } from "lodash";

class UserPodcastExpirationCellViewStore extends MrbBaseViewStore {
    @observable item = null;
    @observable isDisabled = false;

    get userId() {
        return this.userPodcastExpirationViewStore.userId;
    }

    constructor(rootStore, { item, userPodcastExpirationViewStore }) {
        super(rootStore);
        makeObservable(this);
        this.setItem(item);
        this.userPodcastExpirationViewStore = userPodcastExpirationViewStore;
        this.routeStore = this.userPodcastExpirationViewStore.routeStore;
    }

    @action.bound
    setItem(item) {
        this.item = item;
    }

    @action.bound
    setIsDisabled(isDisabled) {
        this.isDisabled = isDisabled;
    }

    handleExpirationDateChange = (value) => {
        if (isNil(value) && !isNil(this.item.userPodcastExpirationId)) {
            return this.deleteExpirationDate();
        } else {
            if (!isNil(this.item.userPodcastExpirationId)) {
                return this.updateExpirationDate(value);
            } else {
                return this.createExpirationDate(value);
            }
        }
    };

    @action.bound
    async createExpirationDate(value) {
        this.setIsDisabled(true);
        const response =
            await this.userPodcastExpirationViewStore.createExpirationDate(
                this.item.podcastId,
                value
            );
        runInAction(() => {
            this.item = response;
            this.setIsDisabled(false);
        });
    }

    @action.bound
    async updateExpirationDate(value) {
        this.setIsDisabled(true);
        const response =
            await this.userPodcastExpirationViewStore.updateExpirationDate(
                this.item.podcastId,
                value
            );
        runInAction(() => {
            this.item = response;
            this.setIsDisabled(false);
        });
    }

    @action.bound
    async deleteExpirationDate() {
        this.setIsDisabled(true);
        const response =
            await this.userPodcastExpirationViewStore.deleteExpirationDate(
                this.item.podcastId
            );
        runInAction(() => {
            this.item = response;
            this.setIsDisabled(false);
        });
    }
}

export default UserPodcastExpirationCellViewStore;
